export default __webpack_public_path__ + "images/40db88bdfab590e8c91d298ec6e2ab1d-mountain_biking.webp";